import React, { useState, useReducer, useEffect, useRef } from 'react'
import Hammer from "react-hammerjs"
import { ReactSVG } from 'react-svg'
import cx from 'classnames'
import s from './CharacterSelect.module.scss'

import store from 'store'
import { setState } from 'store/game'
import AudioManager from 'scripts/util/AudioManager'
import { getAllCharacters } from 'scripts/util/Character'
import {useParams} from "react-router-dom";

import BgImg from 'assets/images/2024-ui/background-2.jpg'
import Snowflake from 'assets/images/snowflake-instructions-2.png'
import useQuery from "hooks/useQuery";

import BackgroundCorners from "components/BackgroundCorners";

const CHARACTERS = getAllCharacters()

const initialState = {index: 0, navIndex: 0, direction: 'right', useNav: false, animating: false };

function reducer(state, action) {
  const key = state.useNav ? 'navIndex' : 'index'
  const maxIndex = state.useNav ? 2 : CHARACTERS.length

  switch (action.type) {
    case 'increment':
      return {
        ...state,
        [key]: (state[key] + 1 + maxIndex) % maxIndex,
        direction: 'right',
      }
    case 'decrement':
      return {
        ...state,
        [key]: (state[key] - 1 + maxIndex) % maxIndex ,
        direction: 'left',
      }
    default:
      return {
        ...state
      }
  }
}

export default function CharacterSelect({ onComplete }) {
  const lang = useQuery().get("lang") || "en";
  const [state, dispatch] = useReducer(reducer, initialState);
  const [charactersAnimating, _setCharactersAnimating] = useState(false)
  const prevIndex = useRef(0)
  const animating = useRef(false)

  const translate = {
    heading : {
      en: "Select a<br/>Character",
      es: "Selecciona un&nbsp;personaje",
    },
    swipeInstruction: {
      en: "Swipe to select",
      es: "Desliza para seleccionar",
    },
    ctaButton: {
      en: "Next",
      es: "Avanzar",
    }
  }

  const setCharactersAnimating = (val) => {
    _setCharactersAnimating(val)
    animating.current = val
  }

  // wait for remote to be complted, then tell parent
  useEffect(() => {
    if (state.index !== prevIndex.current) {
      prevIndex.current = state.index
      setCharactersAnimating(true)
      setTimeout(() => {
        setCharactersAnimating(false)
      }, 700)
    }
  }, [
    state.index,
  ])

  const isPrev = (index, newIndex) => {
    if (newIndex === 0) {
      return index === CHARACTERS.length - 1
    }
    return index === newIndex - 1
  }

  const isNext = (index, newIndex) => {
    if (newIndex === CHARACTERS.length - 1) {
      return index === 0
    }
    return index === newIndex + 1
  }

  const isCharacterHappy = (index) => {
    return state.index === index && !charactersAnimating
  }

  const onSwipe = ({ direction }) => {
    if (animating.current) {
      return
    }

    switch (direction) {
      case 2: //left
      case 8: //up
        setCharactersAnimating(true)
        setTimeout(() => {
          dispatch({type: 'increment'})
        }, 50)
        break;
      case 4: //right
      case 16: //down
        setCharactersAnimating(true)
        setTimeout(() => {
          dispatch({type: 'decrement'})
        }, 50)
        break;
      default:
        // do nothing
    }
  }

  const onSubmit = () => {
    AudioManager.playSound('uiAccept')
    store.dispatch(setState({character: CHARACTERS[state.index].id}))
    onComplete()
  }

  return (
    <div className={s.CharacterSelect}>
      <div className={s.background}>
        <img src={BgImg} alt="" className={s.bg} />
        <BackgroundCorners />
      </div>
      <div className={s.content}>
        <div className={s.contentInner}>
          <h1 className={s.title} dangerouslySetInnerHTML={{__html: translate.heading[lang]}}></h1>
            <Hammer onSwipe={onSwipe} direction="DIRECTION_ALL">
              <div className={cx(s.characters, s[state.direction])}>
                {CHARACTERS.map((item, index) => {
                  return (
                    <div
                    className={cx(s.character, s[item.id], {[s.active]:state.index === index, [s.happy]: isCharacterHappy(index)}, {[s.prev]: isPrev(index, state.index)}, {[s.next]: isNext(index, state.index)})}
                    key={`character${index}`}>
                      <div className={s.characterImgWrapper}>
                        <img className={s.characterImg} src={item.img.src} alt={item.img.alt} />
                        <img className={cx(s.characterImg, s.happy)} src={item.imgHappy.src} alt={item.img.alt} />
                        <div className={s.titleWrapper}>
                          <img className={s.snowflake} src={Snowflake} alt='' />
                          <ReactSVG className={s.title} src={item.titleImg[lang].src} alt={item.titleImg[lang].alt} />
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
            </Hammer>
          </div>
        <div className={s.nextWrapper}>
          <p className={s.helperText}>
            {translate.swipeInstruction[lang]}
          </p>
          <button className="btn md" onClick={onSubmit}>{translate.ctaButton[lang]}</button>
        </div>
      </div>
    </div>
  );
}
